import { render, staticRenderFns } from "./ShieldWithCheckMarkIcon.vue?vue&type=template&id=82251a90&scoped=true&"
import script from "./ShieldWithCheckMarkIcon.vue?vue&type=script&lang=js&"
export * from "./ShieldWithCheckMarkIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShieldWithCheckMarkIcon.vue?vue&type=style&index=0&id=82251a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82251a90",
  null
  
)

export default component.exports